export const GET_PRINT_ACTIVITY_INIT = "GET_PRINT_ACTIVITY_INIT"
export const GET_PRINT_ACTIVITY_SUCCESS = "GET_PRINT_ACTIVITY_SUCCESS"
export const GET_PRINT_ACTIVITY_ERROR = "GET_PRINT_ACTIVITY_ERROR"
export const RESET_GET_PRINT_ACTIVITY = "RESET_GET_PRINT_ACTIVITY"